// NODE_ENV appears to be misreporting 'development' in host.
export const isLocalhost = () =>
  window.location.hostname === 'localhost' ||
  window.location.hostname === 'loopback' ||
  window.location.port.startsWith('300');

export const OB_NEXT_GEN_REDUCER_KEY = 'obNextGenApis';
export const APPLICATION_ICON_REDUCER_KEY = 'applicationIcon';
export const DISCOVERY_PAGE_REDUCER_KEY = 'discoveryPageApis';

let config = {
  BASE_URL_OB_NEXT_GEN: '', // Default value
};

export const initializeObNextGenConfig = (env: {
  BASE_URL_OB_NEXT_GEN?: string;
}) => {
  config = { ...config, ...env };
};

export const getBaseUrlObNextGen = () =>
  config.BASE_URL_OB_NEXT_GEN && config.BASE_URL_OB_NEXT_GEN.length > 0
    ? `${config.BASE_URL_OB_NEXT_GEN}/ECMv6/api`
    : `${window.location.origin}/ECMv6/api`;

export const getObNextGenApiUrlLists = () => ({
  GET_APPLICATIONS: '/idw/admin/applications?category=2&catalog=false',
  GET_DISCOVERY_CONFIG_BY_ID: '/idw/iob/v1/discovery/',
  GET_APPLICATIONTYPE_METADATA: '/idw/admin/applications/aob/features/',
  GET_APPLICATION_ICONS: '/idw/resource/image/app',
  GET_FORM_TEMPLATE: '/idw/admin/applications/generatecategorytemplate',
  SAVE_CONNECTION: '/idw/iob/v1/discovery/save',
  DISCOVERY_FILE_UPLOAD: '/idw/disconnectedapp/uploadfile',
  DISCOVERY_SAMPLE_FILE_DOWNLOAD:
    '/idw/disconnectedapp/downloadfile/application-discovery-sample-data',
  INTEGRATION_ALL_TAB: '/idw/iob/v1/apps',
  START_IMPORT: '/idw/iob/v1/discovery/startImport',
  CHANGE_DISCOVER_APP_STATUS: '/idw/iob/v1/apps',
  SAVE_DISCOVERY_CONFIG: '/idw/iob/v1/discovery',
  GET_CONNECTION_LIST: '/idw/iob/v1/discovery/connections',
});

export const getObNextgenTagTypes = () => ({
  APPLICATION: 'Application',
  DISCOVERY_PAGE: {
    GET_APPLICATIONS: 'DISCOVERY_GET_APPLICATIONS',
    FORM_TEMPLATE: 'DISCOVERY_FORM_TEMPLATE',
    SAVE_CONNECTION: 'DISCOVERY_SAVE_CONNECTION',
    GET_CONNECTION_LIST: 'DISCOVERY_CONNECTION_LIST',
  },
});
export const ComingAppIcons = ['GCP', 'Freshdesk', 'Jira', 'Okta'];

export const defaultDescriptionMessage =
  'Prompt users to answer knowledge-based authentication (KBA) questions.';

export const DEFAULT_TIMEOUT = 100000;
export const AXIOS_TIMEOUT_ERROR_MESSAGE =
  'Not able to verify due to a network issue. Please refresh or try again later.';

export const pageMaps = [
  {
    value: 'Applications',
    route: '/design/catalogManagement',
  },
  {
    value: 'Discovery Sources',
    route: '/integrations/discovery',
  },
];

export const LOAD_INCREMENT_LIST = 25;
